export default __webpack_public_path__ + "static/media/loading.ccaed95b.gif";